export async function getBase64FromBlob(blob: Blob): Promise<string> {
    const reader = new FileReader();

    await new Promise((resolve, reject) => {
        reader.onload = resolve;
        reader.onerror = reject;
        reader.readAsDataURL(blob);
    });

    return reader.result as string;
}
